<template>
  <div class="my-message all-order-content">
    <div class="breadcrumb" style="margin-bottom: 20px;">banner页设置</div>
    <div class="right-content">
      <el-form ref="bannerForm" label-width="160px" :model="bannerForm" :rules="rules" class="demo-form-inline">
        <el-form-item label="推广定位" prop="type">
          <el-select v-model="bannerForm.type" placeholder="请选择">
            <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="pc端首页图片" prop="pcImage">
          <el-upload :class="{ hide_uploadbtn: bannerForm.pcImage }" action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showPcImagePreview" :on-remove="removePcImage"
            :file-list="pcImages" :http-request="uploadPcImage" :multiple="false" :limit="1">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="PC端详情" prop="pcDetail">
          <el-upload class="avatar-uploader upload_warp_left" id="uploadPcDetailImg" style="display:none" action="#" :http-request="uploadPcDetailImg">
          </el-upload>
          <quill-editor id="editor" class="content" :options='editorOption' @change="$refs.bannerForm.validateField('pcDetail')" v-model="bannerForm.pcDetail" ref="pcQuillEditor"
            style="max-width: 900px;">
          </quill-editor>
        </el-form-item>
        <el-form-item label="移动端首页图片" prop="phoneImage">
          <el-upload :class="{ hide_uploadbtn: bannerForm.phoneImage }" action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showPhoneImagePreview" :on-remove="removePhoneImage"
            :file-list="phoneImages" :http-request="uploadPhoneImage" :multiple="false" :limit="1">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="移动端详情" prop="phoneDetail">
          <el-upload class="avatar-uploader upload_warp_left" id="uploadPhoneDetailImg" style="display:none" action="#" :http-request="uploadPhoneDetailImg">
          </el-upload>
          <quill-editor id="editor2" class="content" :options='editorOptionMobile' @change="$refs.bannerForm.validateField('phoneDetail')" v-model="bannerForm.phoneDetail" ref="phoneQuillEditor"
            style="max-width: 900px;">
          </quill-editor>
        </el-form-item>
        <el-form-item label="关联产品" prop="relationId">
          <span style="margin-right:10px">{{ bannerForm.name }}</span>
          <el-button @click="chanpinDialog = true" round>查询</el-button>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-select v-model="bannerForm.sort" placeholder="请选择">
            <el-option v-for="item in 5" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="(this.type === 'edit' && this.bannerForm.bannerId !== null) || this.bannerForm.bannerId === null">
          <el-button type="primary" @click="saveBanner" round>确 定</el-button>
        </el-form-item>
      </el-form>
      <el-dialog :close-on-click-modal="false" :visible.sync="showImgPreview">
        <img width="100%" :src="previewImage" alt="">
      </el-dialog>
      <!-- 关联产品选择 -->
      <el-dialog :close-on-click-modal="false" title="我的产品" :visible.sync="chanpinDialog" width="65%">
        <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
          <!-- <el-row> -->
          <!-- <el-col :span="6"> -->
          <el-form-item label="产品名称:">
            <el-input v-model="formInline.spuName" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :span="6"> -->
          <el-form-item label="产品分类:" v-permission="'pms:admin:category:list'">
            <el-cascader :show-all-levels="false" placeholder="请选择" clearable v-model="formInline.categoryId" :props="props">
            </el-cascader>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :span="6"> -->
          <el-form-item label="产品属性:">
            <el-select v-model="formInline.isSeries" placeholder="请选择" clearable>
              <el-option label="" value="">全部</el-option>
              <el-option label="普通产品" value="0"></el-option>
              <el-option label="套系产品" value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col> -->
          <!-- </el-row> -->
          <!-- <el-row> -->
          <!-- <el-col :span="6" v-permission="'pms:admin:property:list'"> -->
          <el-form-item label="产品性质:">
            <el-select v-model="formInline.spuProperty" placeholder="请选择" clearable>
              <el-option label="" value="">全部</el-option>
              <el-option v-for="item in natureList" :key="item.id" :label="item.dictValue" :value="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col :span="6" class="fn-right form-btn"> -->
          <el-button class="fn-right search-ok" @click="onSubmit" round>查询</el-button>
          <!-- </el-col> -->
          <!-- </el-row> -->
        </el-form>
        <div class="data-list">
          <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
            <el-table-column prop="spuName" label="产品名称" min-width="10px">
            </el-table-column>
            <el-table-column label="产品图片" min-width="10">
              <template v-slot="scope">
                <img :src="scope.row.spuImage" alt="">
              </template>
            </el-table-column>
            <el-table-column prop="cate" label="产品类别" min-width="10">
            </el-table-column>
            <el-table-column prop="propertyName" label="产品性质" min-width="10">
              <template slot-scope="scope"> {{ scope.row.spuProperty === 'NORMAL' ? '通货' : scope.row.spuProperty === 'CUSTOM' ? '定制' : '未定义' }} </template>
            </el-table-column>
            <el-table-column prop="propertyName" label="产品属性" min-width="10">
              <template slot-scope="scope"> {{ scope.row.isSeries ? '套系产品' : '普通产品' }} </template>
            </el-table-column>
            <el-table-column label="操作" min-width="10px">
              <template v-slot="scope">
                <span class="color-blue" @click="choice(scope.row)"> 选择 </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--    分页-->
        <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import VPagination from '@/components/Pagination/index.vue'

import { getBannerDetail, addBanner, updateBanner, getBannerPage } from '@/api/banner'
import uploadWebImg from '@/utils/uploadWebImg'
import { spuList, categoryGet, categoryList, spuProperty, queryAllSubs } from '@/api/pms'
import { resolve } from 'path'
export default {
  name: 'banner-detail',
  components: {
    VPagination
  },
  data () {
    const toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
      ['blockquote', 'code-block'], // 引用，代码块
      [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
      [{ list: 'ordered' }, { list: 'bullet' }], // 列表
      [{ script: 'sub' }, { script: 'super' }], // 上下标
      [{ indent: '-1' }, { indent: '+1' }], // 缩进
      [{ direction: 'rtl' }], // 文本方向
      [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
      [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
      [{ font: [] }], // 字体
      [{ align: [] }], // 对齐方式
      ['clean'], // 清除字体样式
      ['image', 'video'] // 上传图片、上传视频
    ]
    return {

      props: !this.$hasPermission('pms:admin:category:list') ? {} : {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad (node, resolve) {
          const { level, value } = node
          if (level === 0) {
            categoryList(value).then(res => {
              let nodes = res.data.data.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.bottom || item.id === 4
                }
              })
              resolve(nodes)
            })
          } else if (level === 1) {
            queryAllSubs(value).then(res => {
              let nodes = res.data.data.subCategoryList.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.subCategoryList.length === 0,
                  subCategoryList: item.subCategoryList
                }
              })
              resolve(nodes)
            })
          } else {
            let nodes = node.data.subCategoryList.map(item => {
              return {
                value: item.id,
                label: item.categoryName,
                leaf: item.subCategoryList.length === 0,
                subCategoryList: item.subCategoryList
              }
            })
            resolve(nodes)
          }
        }
      },

      rules: {
        type: [
          { required: true, message: '请选择推广定位', trigger: 'change' }
        ],
        pcImage: [
          { required: true, message: '请上传PC端首页图片', trigger: 'blur' }
        ],
        pcDetail: [
          { required: true, message: '请输入PC端详情', trigger: 'blur' }
        ],
        phoneImage: [
          { required: true, message: '请上传移动端首页图片', trigger: 'blur' }
        ],
        phoneDetail: [
          { required: true, message: '请输入移动端详情', trigger: 'blur' }
        ],
        spuName: [
          { required: true, message: '请关联产品', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请选择排序', trigger: 'change' }
        ]

      },
      bannerForm: {
        bannerId: null,
        pcImage: '',
        pcDetail: '',
        phoneImage: '',
        phoneDetail: '',
        relationId: null,
        sort: '',
        type: null,
        name: ''
      },
      formInline: {
        spuName: '', // 产品名称
        categoryId: '', // 产品类别
        isSeries: '', // 产品属性
        spuProperty: '', // 产品性质
        onSale: 1
      },
      categoryList: [],
      treeDataValue: '',
      defaultProps: {
        // children: 'children',
        label: 'name'
      },
      natureList: [],
      chanpinDialog: false, // 关联产品弹窗
      tableData: [], // 关联产品弹窗表格数据
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      // showPcImage: true,
      // showPhoneImage: true,
      showImgPreview: false,
      previewImage: '',
      pcImages: [],
      phoneImages: [],
      types: [
        {
          label: '新品发布',
          value: '0'
        },
        {
          label: '项目展示',
          value: '1'
        }
        // {
        //   label: 'C端活动推广',
        //   value: '2'
        // }
      ],
      editorOptionMobile: {
        placeholder: '请编辑内容',
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector('#uploadPhoneDetailImg input').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      editorOption: {
        theme: 'snow',
        placeholder: '请编辑内容',
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector('#uploadPcDetailImg input').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      }

    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  async created () {
    await this.getProList(this.queryInfo)
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    this.bannerForm.bannerId = this.$route.query.id
    this.type = this.$route.query.type
    if (this.bannerForm.bannerId) {
      await this.getBannerDetail(this.bannerForm.bannerId)
    }
    if (this.$hasPermission('pms:admin:property:list')) {
      // 获取产品性质
      this.getProNature()
    }
  },
  methods: {
    // 上传产品phone端详情图片
    uploadPhoneDetailImg (e) {
      if (e.file.type !== 'image/jpeg' && e.file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.phoneQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    // 上传产品PC端详情图片
    uploadPcDetailImg (e) {
      if (e.file.type !== 'image/jpeg' && e.file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.pcQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    async getBannerDetail (bannerId) {
      await getBannerDetail(bannerId).then(res => {
        if (res.data.success) {
          this.bannerForm = res.data.data
          this.bannerForm.bannerId = this.bannerForm.id
          this.pcImages = [{ url: this.bannerForm.pcImage }]
          // this.showPcImage = false
          this.phoneImages = [{ url: this.bannerForm.phoneImage }]
          // this.showPhoneImage = false
          let obj = this.tableData.find(v => v.id === this.bannerForm.relationId)
          this.choice(obj)
        }
      })
    },
    removePcImage (file, fileList) {
      this.bannerForm.pcImage = ''
    },
    showPcImagePreview () {
      this.showImgPreview = true
      this.previewImage = this.bannerForm.pcImage
    },
    uploadPcImage (e) {
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          this.bannerForm.pcImage = res
          this.showPcImage = false
          this.$refs.bannerForm.validateField('pcImage')
        } else {
          this.$message.error('图片上传失败')
        }
      })
    },
    removePhoneImage (file, fileList) {
      this.bannerForm.phoneImage = ''
    },
    showPhoneImagePreview () {
      this.showImgPreview = true
      this.previewImage = this.bannerForm.phoneImage
    },
    uploadPhoneImage (e) {
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          this.bannerForm.phoneImage = res
          this.showPcImage = false
          this.$refs.bannerForm.validateField('phoneImage')
        } else {
          this.$message.error('图片上传失败')
        }
      })
    },
    saveBanner () {
      this.$refs.bannerForm.validate(async (valid) => {
        console.log(valid)
        if (!valid) {
          return
        }

        if (this.bannerForm.bannerId == null) {
          // 推广定位新品发布数量判断 0代表新品发布
          if (this.bannerForm.type === '0') {
            // 发送请求获取已有数据
            const res = await getBannerPage({
              vo: { type: '0' },
              params: {
                page: 1,
                size: 10,
                sort: 'dateCreated,desc'
              }
            })
            if (res.data.success) {
              const data = res.data.data.records.filter(t => t.type === '0')
              if (data.length >= 5) {
                this.$message.error('新品发布数量不能大于5项')
                return
              }
            }
          }
          addBanner(this.bannerForm).then(res => {
            if (res.data.success) {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
          }
          )
        } else {
          updateBanner(this.bannerForm).then(res => {
            if (res.data.success) {
              if (res.data.success) {
                this.$notify({
                  title: '成功',
                  message: '保存成功',
                  type: 'success'
                })
                this.$router.go(-1)
              }
            }
          })
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    choice (content) {
      this.chanpinDialog = false
      this.bannerForm.relationId = content.id
      this.bannerForm.name = content.spuName
    },
    aaaa (item, str, list) {
      if (item.subCategory !== undefined) {
        str = '>' + item.categoryName + str
        return this.aaaa(item.subCategory, str, list)
      } else {
        str = item.categoryName + str
        list.ownCategoryId = item.id
        return str
      }
    },
    async getProList (val) {
      await spuList({ pageNum: val.pageNum, pageSize: val.pageSize, spuVO: this.formInline }).then((res) => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getProList(this.queryInfo)
          }
          let list = res.data.data.records
          list.forEach((item, index) => {
            item.cate = this.aaaa(item.category, '', item)
          })
          this.tableData = list.filter(v => v.onSale)
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    handNodeClick (data, node, nodeData) {
      if (node.childNodes.length === 0) {
        this.treeDataValue = data
        this.formInline.categoryId = data.name
        this.$refs.multiSelect.blur()
      }
    },
    onSubmit () {
      this.getProList(this.queryInfo)
    },
    changePage (val) {
      this.queryInfo = val
      this.getProList(this.queryInfo)
    },
    getProCate () {
      // 获取产品类
      categoryList().then((res) => {
        this.categoryList = res.data.data
      })
    },
    getProNature () {
      // 获取产品性质
      spuProperty().then((res) => {
        this.natureList = res.data.data
      })
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";

@{deep} .pc_detail {
  width: 100%;

  img {
    width: 100%;
  }
}

@{deep} .hide_uploadbtn .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

// @{deep} .ql-container .ql-snow {
//   height: 500px;
// }
@{deep} .ql-container {
  height: auto !important;
}

.quill-editor {
  width: 70%;

  @{deep} .ql-editor {
    min-height: 400px;
  }

  @{deep} .ql-toolbar {
    .ql-picker-label {
      height: auto;
    }

    .ql-picker.ql-expanded .ql-picker-options {
      top: auto;
    }
  }
}

@{deep} .el-cascader {
  line-height: 0;
}
</style>
